<template>
  <div class="login" @click.stop="bindStop">
    <div class="title">{{ title }}</div>
    <div class="close iconfont icon-cha" @click="bindClose"></div>
    <div class="form">
      <!-- <div class="item">
          <div class="item-title">您的昵称</div>
          <div class="item-bottom">
            <input
              class="item-input"
              type="text"
              v-model="username"
              @blur="checkUserName(username)"
              placeholder="请输入您的姓名"
              maxlength="20"
            />
          </div>
        </div> -->
      <div class="item">
        <div class="item-title">手机号</div>
        <div class="item-bottom">
          <input
            class="item-input"
            type="number"
            maxlength="20"
            v-model="phone"
            @blur="checkPhone(phone)"
            placeholder="请输入您的手机号码"
          />
        </div>
      </div>
      <div class="item">
        <div class="item-title">验证码</div>
        <div class="item-bottom">
          <input
            class="item-input"
            type="number"
            placeholder="请输入验证码"
            @blur="checkCode(code)"
            maxlength="4"
            v-model="code"
          />
          <div class="code" @click="bindSendCode">
            {{ codeTime ? codeTime + 'S' : '获取验证码' }}
          </div>
        </div>
      </div>
      <div class="item" v-if="haveExchange">
        <div class="item-title">兑换码</div>
        <div class="item-bottom">
          <input
            class="item-input"
            type="text"
            placeholder="请输入兑换码"
            @blur="checkExchangeCode(exchangeCode)"
            maxlength="20"
            v-model="exchangeCode"
          />
        </div>
      </div>
    </div>
    <div
      class="confirm-btn"
      :class="{ 'btn-disabled': disabledLogin }"
      @click="bindLogin"
    >
      确认领取
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '填写您的信息'
    },
    haveExchange: {
      type: Boolean,
      default: false //是否有兑换码
    }
  },
  data() {
    return {
      disabledSend: false, //是否禁用发送验证码
      codeTime: 0, //验证码等待时间
      timer: null,
      username: '',
      phone: '',
      code: '',
      exchangeCode: ''
    }
  },
  computed: {
    disabledLogin() {
      let disabledLogin = !this.phone || !this.code
      return disabledLogin
    }
  },
  watch: {
    code(val) {
      if (val.length > 4) {
        this.code = val.slice(0, 4)
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    bindStop() {},
    bindClose() {
      this.$emit('close')
    },
    bindSendCode() {
      if (this.disabledSend) {
        return
      }
      if (!this.checkPhone(this.phone)) {
        this.$toast('请检查手机号码长度')
        return
      }
      this.disabledSend = true
      let params = {
        phone: this.phone,
        areaCode: '86'
      }
      this.$http
        .postBaseApp('sendSms', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.$toast('发送成功')
            this.codeInterval()
          } else {
            this.disabledSend = false
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.disabledSend = false
        })
    },
    codeInterval() {
      this.codeTime = 60
      this.timer = setInterval(() => {
        this.codeTime--
        if (this.codeTime <= 0) {
          this.disabledSend = false
          clearInterval(this.timer)
          // this.codeTime = 0;
        }
      }, 1000)
    },
    checkParams() {
      let res =
        this.checkPhone(this.phone) &&
        this.checkCode(this.code) &&
        this.checkExchangeCode(this.exchangeCode)
      return res
    },
    //判断兑换码是否已经填写
    checkExchangeCode(code) {
      //不要填写时跳过判断
      if (!this.haveExchange) {
        return true
      }
      if (!code) {
        this.$toast('请填写兑换码')
        return false
      }
      let reg = /^BTW.+/ //必须以BTW开头，后面至少一个任意字符
      let res = reg.test(code)
      if (!res) {
        this.$toast('兑换码格式错误')
      }
      return res
    },
    //判断用户姓名
    checkUserName(username) {
      if (username.length > 5) {
        this.$toast('姓名只支持中文、英文、数字，不支持特殊字符空格，最多5个字')
        return false
      }
      let reg = /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/
      let res = reg.test(username)
      if (!res) {
        this.$toast('姓名只支持中文、英文、数字，不支持特殊字符空格，最多5个字')
      }
      return res
    },
    checkPhone(phone) {
      if (!phone.length) {
        this.$toast('请输入电话号码')
        return false
      }
      if (phone.length != 11) {
        this.$toast('请检查手机号码长度')
        return false
      }
      return true
    },
    checkCode(code) {
      code = code.trim()
      if (!code) {
        this.$toast('请输入验证码')
      }
      return code
    },
    bindLogin() {
      if (this.disabledLogin) {
        return
      }
      if (!this.checkParams()) {
        return
      }
      console.log('通过')
      let options = {
        phone: this.phone,
        code: this.code
      }
      this.$emit('login', options)
    }
  }
}
</script>
<style lang="scss" scoped>
.login {
  background: #f9f9f9;
  padding: 20px 20px 34px;
  box-sizing: border-box;
  animation: moveup 0.3s ease;
  .title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 20px;
    margin-bottom: 18px;
  }
  .close {
    position: absolute;
    padding: 10px;
    top: 5px;
    right: 5px;
    color: #000;
    font-size: 14px;
  }
  .form {
    padding: 0px 10px;
    box-sizing: border-box;
  }
  .item {
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 17px;
    .item-title {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 22px;
      margin-bottom: 4px;
    }
    .item-input {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      border: none;
      padding: 6px 0px;
      background: transparent;
    }
    .item-bottom {
      display: flex;
      align-items: center;
      padding-bottom: 4px;
    }
    .item-input::placeholder {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.3);
      line-height: 20px;
    }
    .code {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #6236ff;
      line-height: 20px;
    }
  }
  .confirm-btn {
    height: 44px;
    line-height: 44px;
    background: #6236ff;
    border-radius: 12px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
  .btn-disabled {
    background: rgba(0, 0, 0, 0.1);
  }
}
@keyframes moveup {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0%);
  }
}
</style>
